import styled from 'styled-components';
import { SIZE } from '@app/src/ui';

export const GridContent = styled.div`

  @media (min-width: ${SIZE.TABLET_LANDSCAPE}) {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    & > div {
      min-width: 118px;
    }

    & > div:not(:first-child) {
      margin-left: 15px;
    }
  }
`;

export const FormWrapper = styled.form`
  display: flex;
  flex-direction: column;
  height: 100%;
`;